import { StaticQuery, graphql } from "gatsby";
import React from "react";

import {
  Section,
  Image,
  Card,
  Header2,
  Underlined,
  Paragraph,
} from "@racepointenergy/gatsby-theme-sitespark/src/components/Hero";
import {
  getSize,
  hexToRgba,
} from "@racepointenergy/gatsby-theme-sitespark/src/components/Theme/utils";

export const PowerMove = () => (
  <Section
    css={`
      @media screen and (min-width: ${getSize(
          "default"
        )}) and (max-width: 719px) {
        margin-bottom: 0px;
      }
    `}
  >
    <StaticQuery
      query={graphql`
        query GetAPreliminaryProposalPowerMoveHeroImageQuery {
          file(relativePath: { eq: "big_ess.png" }) {
            ...HeroImage
          }
        }
      `}
      render={({ file }) => (
        <Image
          css={`
            + picture > img,
            img {
              object-position: 95% 85%;
            }
          `}
          file={file}
        />
      )}
    />

    <Card
      css={`
        background-color: ${({
          theme: {
            colors: { mayAsWellBeWhite },
          },
        }) => mayAsWellBeWhite};
        @media screen and (min-width: ${getSize(
            "default"
          )}) and (max-width: 479px) {
          padding: 31px 38px 26px 19px;
        }
        @media screen and (min-width: ${getSize("mobile480")}) {
          padding-bottom: 27px;
        }
        @media screen and (min-width: ${getSize("tablet720")}) {
          background-color: ${({
            theme: {
              colors: { offWhite },
            },
          }) => hexToRgba(offWhite, 0.9)};
        }
        @media screen and (min-width: ${getSize(
            "tablet720"
          )}) and (max-width: 1199px) {
          padding-right: 42px;
          width: 384px;
        }
        @media screen and (min-width: ${getSize("desktop1200")}) {
          padding: 76px 72px 72px 80px;
          width: 526px;
        }
        @media screen and (min-width: ${getSize("desktop1920")}) {
          padding: 76px 72px 72px 80px;
          width: 526px;
        }
      `}
    >
      <Header2
        css={`
          width: 210px;
          @media screen and (min-width: ${getSize("mobile480")}) {
            width: 100%;
          }
          @media screen and (min-width: ${getSize("tablet720")}) {
            width: 210px;
          }
          @media screen and (min-width: ${getSize("tablet960")}) {
            width: 100%;
          }
        `}
      >
        {"Make a "}
        <br
          css={`
            display: none;
            @media screen and (min-width: ${getSize("tablet720")}) {
              display: initial;
            }
          `}
        />
        {"Power Move"}
        <Underlined />
      </Header2>
      <Paragraph
        css={`
          @media screen and (min-width: ${getSize(
              "desktop1200"
            )}) and (max-width: 1919px) {
            font-size: 20px;
            line-height: 31px;
            width: 374px;
          }
        `}
      >
        {
          "Take control of your energy consumption and lose your dependence on the grid. A Savant Power Microgrid puts the power back in the hands of the consumer."
        }
      </Paragraph>
    </Card>
  </Section>
);

PowerMove.propTypes = {};
